/**
 * @generated SignedSource<<c90d8c5dde63bf6a50f511777cfe35b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteSkillInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteSkillMutation$variables = {
  input: DeleteSkillInput;
};
export type deleteSkillMutation$data = {
  readonly deleteSkill: {
    readonly deletedSkillId: string | null;
  } | null;
};
export type deleteSkillMutation = {
  variables: deleteSkillMutation$variables;
  response: deleteSkillMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSkillPayload",
    "kind": "LinkedField",
    "name": "deleteSkill",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSkillId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteSkillMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteSkillMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "315dff7aaaabaa854eac8e6a00d2b766",
    "id": null,
    "metadata": {},
    "name": "deleteSkillMutation",
    "operationKind": "mutation",
    "text": "mutation deleteSkillMutation(\n  $input: DeleteSkillInput!\n) {\n  deleteSkill(input: $input) {\n    deletedSkillId\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b7a322828aa75a0e7b48916e50ad285";

export default node;
